// ==================== 类型定义 ====================
export interface SupplierRecord {
  id: number;
  registerSource: number; // 注册来源
  supplierName: string; // 供应商名称
  supplierUsName: string; // 供应商英文名称
  email: string; // 注册邮箱
  contactName: string; // 联系人
  contactPhone: string; // 联系电话
  inviter: string; // 邀请人
  inviteDate: string; // 邀请日期
  registrationStatus: number; // 注册状态
  lastLoginDate?: string; // 最近登录时间
}

export type RegisterStatus = "pending" | "approved" | "rejected";

// ==================== 常量配置 ====================

// 注册来源映射
export const REGISTER_SOURCE_MAP: Record<number, string> = {
  1: "自主注册",
  2: "代注册",
};

// 注册状态映射
export const REGISTER_STATUS_MAP: Record<
  number,
  { color: string; text: string }
> = {
  1: { color: "#C3C3C3", text: "待注册" },
  2: { color: "#57E0FF", text: "草稿" },
  3: { color: "#FFB700", text: "待审核" },
  4: { color: "#00B42A", text: "已通过" },
  5: { color: "#F53F3F", text: "驳回" },
  6: { color: "#666666", text: "禁用" },
  7: { color: "#FFB700", text: "供应商修改信息后待审核" },
  8: { color: "#F53F3F", text: "供应商修改信息后驳回" },
};

export const STATUS_OPTIONS = [
  { label: "待注册", value: 1 },
  { label: "草稿", value: 2 },
  { label: "待审核", value: 3 },
  { label: "已通过", value: 4 },
  { label: "驳回", value: 5 },
  { label: "禁用", value: 6 },
  { label: "供应商修改信息后待审核", value: 7 },
  { label: "供应商修改信息后驳回", value: 8 },
];

// 语言选项
export const LANGUAGE_OPTIONS = [
  { label: "简体中文", value: "zh_CN" },
  { label: "繁体中文", value: "zh_HK" },
  { label: "English", value: "en_US" },
];

// ==================== Modal 配置 ====================
export type ModalMode = "register" | "edit" | "audit" | "view";

export const getModalTitles = (
  t: (key: string) => string,
): Record<ModalMode, string> => ({
  register: t("供应商注册信息表"),
  edit: t("编辑供应商信息"),
  audit: t("审核供应商信息"),
  view: t("查看供应商信息"),
});

export const getButtonLabels = (
  t: (key: string) => string,
): Record<ModalMode, { save: string; cancel: string }> => ({
  register: { save: t("提交"), cancel: t("取消") },
  edit: { save: t("保存"), cancel: t("取消") },
  audit: { save: t("确定"), cancel: t("取消") },
  view: { save: "", cancel: t("关闭") },
});
